import { useMemo } from 'react'
import { cards } from '../../constants/cards'
import HomeCard from './HomeCard'
import './home.css'
import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'
import { useAuthContext } from '../../context'
import CustomTour from '../../components/CustomTour'

const Home = () => {
  const { userDetails, isLoading } = useAuthContext()
  const mappedCards = useMemo(() => {
    return cards.map((card, index) => (
      <HomeCard
        className={index === 0 ? 'grids-card' : ''}
        index={index}
        card={card}
        key={`home-card-${index}`}
      />
    ))
  }, [])
  return (
    <DashboardLayout hideMarginTop={true}>
      <div className="flex items-center justify-start flex-col">
        <div className="text-3xl lg:ml-[10%] font-bold flex items-center flex-col  sm:text-3xl w-full lg:items-start ">
          <div className="text-over-primary-background">
            {!isLoading ? (
              <span>
                {userDetails.name ? 'Hei, ' : 'Hei'}
                <span className="text-primary font-bold">
                  {userDetails.name ?? ''}
                </span>
                !
              </span>
            ) : (
              <div className="h-[40px] bg-primary-skeleton rounded w-[200px]  animate-pulse page-loading"></div>
            )}
          </div>
          <div className="font-bold text-over-primary-background mt-1 text-sm">
            {userDetails.email !== null ? userDetails.email : ''}
          </div>
        </div>

        <div className="w-full  lg:ml-[10%] flex lg:justify-start justify-center">
          <div className="grid border-t pt-3 border-gray-300 grid-cols-2 mt-4 lg:grid-cols-3 sm:w-[60%] w-[90%]  gap-5">
            {mappedCards}
          </div>
        </div>
      </div>
      <CustomTour isOpen={!isLoading} />
    </DashboardLayout>
  )
}

export default Home
